import React from "react";

const holder = {
  closeFiltersDropdown(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.outlet({ startDate: holder.startDate, endDate: holder.endDate })
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closeFiltersDropdown)
    }
  }
};


export default {
  'CalendarBoxDropdown.Wrapper': async ({ isOpen, containerRef, startDate, endDate }, outlet, internalStateSetter) => {
    if (isOpen) {
      return;
    }

    let newContainerRef = containerRef;

    if (!containerRef) {
      newContainerRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef });
    }

    await internalStateSetter({ isOpen: true });
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;
    holder.startDate = startDate;
    holder.endDate = endDate;
    holder.outlet = outlet;

    document.addEventListener("mousedown", holder.closeFiltersDropdown);
  },
  'CalendarBoxDropdown.Wrapper.BodyWrapper.Body.CustomHeader': ({ action, endDate, startDate, selectedDate }, outlet, internalStateSetter) => {
    if (action === 'selectStartDate') {
      internalStateSetter({ editingDate: 'startDate' })
    }
    if (action === 'selectEndDate') {
      internalStateSetter({ editingDate: 'endDate' })
    }
    if (action === 'changeStartDate') {
      holder.startDate = selectedDate;
      let endDateNew = selectedDate && endDate && (selectedDate > endDate) ? selectedDate : endDate;
      holder.endDate = endDateNew;
      internalStateSetter({ startDate: selectedDate, endDate: endDateNew, editingDate: 'endDate' });
      outlet({ startDate: selectedDate, endDate: endDateNew })
    }
    if (action === 'changeEndDate') {
      holder.endDate = selectedDate;
      let startDateNew = startDate && selectedDate && (selectedDate < startDate) ? selectedDate : startDate;
      holder.startDate = startDateNew;
      internalStateSetter({ endDate: selectedDate, startDate: startDateNew });
      outlet({ startDate: startDateNew, endDate: selectedDate })
    }
  },
  'CalendarBoxDropdown.Wrapper.BodyWrapper.Body.Calendar': ({ selectedDate, editingDate, startDate, endDate }, outlet, internalStateSetter) => {
    if (editingDate === 'startDate') {
      holder.startDate = selectedDate;
      let endDateNew = selectedDate && endDate && (selectedDate > endDate) ? selectedDate : endDate;
      holder.endDate = endDateNew;
      internalStateSetter({ startDate: selectedDate, endDate: endDateNew, editingDate: 'endDate' });
      outlet({ startDate: selectedDate, endDate: endDateNew })
    } else {
      holder.endDate = selectedDate;
      let startDateNew = startDate && selectedDate && (selectedDate < startDate) ? selectedDate : startDate;
      holder.startDate = startDateNew;
      internalStateSetter({ endDate: selectedDate, startDate: startDateNew });
      outlet({ startDate: startDateNew, endDate: selectedDate })
    }
  },
  'CalendarBoxDropdown.Wrapper.HeaderWrapper.LeftSide.SearchTerm': ({ }, outlet) => {
    outlet({ startDate: null, endDate: null })
  }
};
